import React, { useMemo } from 'react';
import { Select, SelectProps } from './Select';
import { LocalizedCountry, useCountries } from '@app/api';

export const CountryKeySelect = <IsMulti extends boolean>(
  props: SelectProps<IsMulti>,
) => {
  const { data: countries } = useCountries();
  const options = useMemo(() => {
    if (!countries) {
      return [];
    }
    const sortedOptions = countries.map((c: LocalizedCountry) => ({
      label: c.text || c.name || c.nativeName,
      value: c.key,
    }));

    const firstsCountries = ['FR', 'BE', 'DE', 'ES', 'NL', 'US', 'GB'];

    const res: Array<{ label: string; value: string }> = [];
    for (const key of firstsCountries) {
      const found = sortedOptions.find((o) => o.value === key);
      if (found) {
        res.push(found);
      }
    }
    return res.concat(
      sortedOptions.filter((o) => !firstsCountries.includes(o.value)),
    );
  }, [countries]);

  return <Select {...props} options={options} />;
};
